import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=c533e3ce&scoped=true&"
import script from "./CatalogSearch.vue?vue&type=script&lang=js&"
export * from "./CatalogSearch.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=c533e3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c533e3ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
